var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loader-wrapper" }, [
      _c("div", { staticClass: "loader" }, [
        _c("div", { staticClass: "roller" }),
        _vm._v(" "),
        _c("div", { staticClass: "roller" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "loader", attrs: { id: "loader2" } }, [
        _c("div", { staticClass: "roller" }),
        _vm._v(" "),
        _c("div", { staticClass: "roller" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "loader", attrs: { id: "loader3" } }, [
        _c("div", { staticClass: "roller" }),
        _vm._v(" "),
        _c("div", { staticClass: "roller" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }